/* MediaThumb1.js */

import React from 'react';
import { IoPlayCircleOutline } from 'react-icons/io5';

const IMAGE_SRC = process.env.REACT_APP_PZ_IMAGE_SRC;
const POPFANS_URL = process.env.REACT_APP_POPFANS_APP_WEB;

export default function MediaThumb1({ photo, callback }) {
  return (
    <div
      className='cursor-pointer grid-image-2'
      onClick={callback}
    >
      <div
        className='preview d-flex align-items-center justify-content-center'
        style={{ backgroundImage: `url(${IMAGE_SRC.replace('{id}', photo.eid)})` }}
      >
        {parseInt(photo.etype) === 2 && (
          <div className='play-icon'>
            <IoPlayCircleOutline />
          </div>
        )}
      </div>
      <p className='text-center mb-2 mt-0'>
        <a className='primary-color' href={`${POPFANS_URL}?u=${photo.eown}`} target='_blank' rel='noreferrer noopener'>
          @{photo.eown}
        </a>
      </p>
    </div>
  );
}
